import { render, staticRenderFns } from "./LightBoxFirstTime.vue?vue&type=template&id=1464a919"
import script from "./LightBoxFirstTime?vue&type=script&lang=ts&external"
export * from "./LightBoxFirstTime?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports